import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled, { withTheme } from "styled-components";
import { ToastOptions } from "../ToastManager/constants";
import { ToastSettings } from "./constants";

const StyledToastHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.4rem 0.75rem;
  color: #6c757d;
  background-color: ${(props) => ToastSettings[props.type].color};
  background-clip: padding-box;
  min-width: 315px;
`;

const StyledToastTitle = styled.strong`
  background-color: ${(props) => ToastSettings[props.type].color};
  color: ${(props) => ToastSettings[props.type].icon};
`;

const StyledToastCardInfo = styled.span`
  text-align: center;
  margin-right: auto;
  font-size: 0.9em;
`;

const StyledToastSymbol = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 5px;
  background-color: ${(props) => ToastSettings[props.type].icon};
`;

const StyledToastBody = styled.div`
  padding: 0.75rem;
  background-color: ${(props) => ToastSettings[props.type].color};
  font-size: 1.1em;
`;

const ToastUGNX = (props) => {
  const [counter, setCounter] = useState(ToastOptions.countDown);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const { type, cardName, toastProps, title } = props;
  return (
    <>
      <StyledToastHeader {...{ type }}>
        <StyledToastSymbol className="mr-2" {...{ type }} />
        <StyledToastTitle className="mr-auto" {...{ type }}>
          {title}
        </StyledToastTitle>
        {cardName && <StyledToastCardInfo>{cardName}</StyledToastCardInfo>}
        {toastProps.autoClose !== false && (
          <small className="font-weight-bolder">
            {counter === ToastOptions.countDown ? "Just Now" : counter}
          </small>
        )}
        <button
          className="ml-3 mb-1 close"
          aria-label="Close"
          onClick={() => toast.dismiss(toastProps?.toastId)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </StyledToastHeader>
      <StyledToastBody {...{ type }}>{props.children}</StyledToastBody>
    </>
  );
};

export default withTheme(ToastUGNX);
